import { computed } from 'vue';
import { useState } from '#app';
import {
  CONSENT_COOKIE,
  CONSENT_MAX_AGE,
  consentRecord,
  readConsent
} from '~/utils/privacy-consent';
export function usePrivacyConsent() {
  // Never serialize one visitor's consent into cached public SSR HTML.
  const state = useState('privacy:consent', () => null);
  const initialized = useState('privacy:initialized', () => false);
  const preferencesOpen = useState('privacy:preferences-open', () => false);
  const record = computed(() => readConsent(state.value));
  const analyticsAllowed = computed(() => record.value?.analytics === true);
  const marketingAllowed = computed(() => record.value?.marketing === true);
  function syncFromCookie() {
    if (!import.meta.client) return;
    try {
      const raw = document.cookie
        .split(';')
        .map((value) => value.trim())
        .find((value) => value.startsWith(CONSENT_COOKIE + '='));
      const next = readConsent(
        raw
          ? JSON.parse(decodeURIComponent(raw.slice(CONSENT_COOKIE.length + 1)))
          : null
      );
      if (JSON.stringify(state.value) !== JSON.stringify(next))
        state.value = next;
    } catch {
      state.value = null;
    }
    initialized.value = true;
  }
  function save(choices) {
    const next = consentRecord(choices);
    if (import.meta.client) {
      document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(next))}; Path=/; Max-Age=${CONSENT_MAX_AGE}; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
      document.cookie = 'cookiesOptedIn=; Path=/; Max-Age=0; SameSite=Lax';
    }
    preferencesOpen.value = false;
    state.value = next; // Shared synchronously by all tracking composables.
    initialized.value = true;
    if (import.meta.client) {
      try {
        localStorage.setItem('idmanify:consent-sync', JSON.stringify(next));
      } catch {
        /* Consent still works without optional browser storage. */
      }
    }
  }
  return {
    record,
    analyticsAllowed,
    marketingAllowed,
    preferencesOpen,
    initialized,
    syncFromCookie,
    save,
    open: () => {
      preferencesOpen.value = true;
    }
  };
}
